export default __webpack_public_path__ + "static/springandsummer (6)-d969c13b5d4adfc0d1b2e5d5b93e6ab4.jpeg";